import {
  MainDashboardElementDefinition,
  MainDashboardElementType,
  ExtendedPanelModel,
  TypesTracker,
} from 'common/models/Dashboard/EditLayout';

export const DefaultMainDashboardElements: MainDashboardElementDefinition[] = [
  {
    id: 'Revenue_Default',
    row: 0,
    col: 0,
    sizeX: 4,
    sizeY: 2,
    minSizeX: 4,
    minSizeY: 2,
    maxSizeX: null,
    maxSizeY: null,
    type: 'Revenue',
    defaultConfig: {
      title: 'My Revenue - This Month',
      userFilterIds: '',
      sourceType: 'currentuser',
      reportPeriod: 1,
    },
  },
  {
    id: 'Revenue_Default_1',
    row: 3,
    col: 0,
    sizeX: 4,
    sizeY: 2,
    minSizeX: 4,
    minSizeY: 2,
    maxSizeX: null,
    maxSizeY: null,
    type: 'Revenue',
    defaultConfig: {
      title: 'My Revenue - This Qtr',
      userFilterIds: '',
      sourceType: 'currentuser',
      reportPeriod: 2,
    },
  },
  {
    id: 'Revenue_Default_2',
    row: 5,
    col: 0,
    sizeX: 4,
    sizeY: 2,
    minSizeX: 4,
    minSizeY: 2,
    maxSizeX: null,
    maxSizeY: null,
    type: 'Revenue',
    defaultConfig: {
      title: 'My Revenue - This Year',
      userFilterIds: '',
      sourceType: 'currentuser',
      reportPeriod: 3,
    },
  },
  {
    id: 'MyOpenJobs_Default',
    row: 0,
    col: 4,
    sizeX: 7,
    sizeY: 3,
    minSizeX: 6,
    minSizeY: 3,
    maxSizeX: null,
    maxSizeY: null,
    type: 'MyOpenJobs',
    defaultConfig: { title: 'My Open Jobs', userFilterIds: '', sourceType: 'currentuser' },
  },
  {
    id: 'CurrentContractors_Default',
    row: 0,
    col: 12,
    sizeX: 4,
    sizeY: 3,
    minSizeX: 4,
    minSizeY: 2,
    maxSizeX: null,
    maxSizeY: null,
    type: 'CurrentContractors',
  },
  {
    id: 'HistoricalBillings_Default',
    row: 3,
    col: 4,
    sizeX: 7,
    sizeY: 3,
    minSizeX: 6,
    minSizeY: 2,
    maxSizeX: null,
    maxSizeY: null,
    type: 'HistoricalBillings',
    defaultConfig: { title: 'Historical Revenue', userFilterIds: '', sourceType: 'currentuser' },
  },
  {
    id: 'Forecast_Default_1',
    row: 3,
    col: 12,
    sizeX: 4,
    sizeY: 3,
    minSizeX: 4,
    minSizeY: 3,
    maxSizeX: null,
    maxSizeY: null,
    type: 'Forecast',
  },
];

export const DefaultMainDashboardElementTypesTracker: TypesTracker = {
  CurrentContractors: false,
  ForecastNextMonth: false,
  ForecastThisMonth: false,
  HistoricalBillings: false,
  MyOpenJobs: false,
  UserInfo: false,
  LinkButton: false,
  Activity: false,
  JobPipeline: false,
  CandidatePipeline: false,
  PlacementFees: false,
  KPI: false,
  Ratio: false,
  Revenue: false,
  '': false,
  BillingsThisMonth: false,
  BillingsThisQtr: false,
  BillingsThisYear: false,
  MyActiveInterviews: false,
  TopPerformers: false,
  Dashboard_NotFound: false,
  Forecast: false,
};

export const GetMinSizeByElementType = (type: MainDashboardElementType) => {
  switch (type) {
    case 'CurrentContractors':
      return [3, 2];
    case 'ForecastNextMonth':
      return [3, 2];
    case 'ForecastThisMonth':
      return [3, 2];
    case 'HistoricalBillings':
      return [4, 2];
    case 'MyOpenJobs':
      return [4, 3];
    case 'UserInfo':
      return [2, 1];
    case 'Activity':
      return [4, 2];
    case 'PlacementFees':
      return [4, 2];
    case 'KPI':
      return [3, 2];
    case 'Ratio':
      return [3, 2];
    case 'Revenue':
      return [4, 2];
    case 'TopPerformers':
      return [3, 2];
    case 'Forecast':
      return [4, 3];

    default:
      return [1, 1];
  }
};

export const GetDefaultSizeByElementType = (type: MainDashboardElementType) => {
  switch (type) {
    case 'CurrentContractors':
      return [3, 2];
    case 'ForecastNextMonth':
      return [3, 2];
    case 'ForecastThisMonth':
      return [3, 2];
    case 'HistoricalBillings':
      return [4, 2];
    case 'MyOpenJobs':
      return [4, 3];
    case 'UserInfo':
      return [2, 1];
    case 'LinkButton':
      return [3, 1];
    case 'Activity':
      return [7, 2];
    case 'JobPipeline':
      return [15, 2];
    case 'CandidatePipeline':
      return [11, 1];
    case 'Revenue':
      return [4, 2];
    case 'TopPerformers':
      return [3, 2];
    case 'Dashboard_NotFound':
      return [15, 1];
    case 'Forecast':
      return [4, 3];
    default:
      return [1, 1];
  }
};

export const GetElementTypeById = (id: string): MainDashboardElementType => {
  if (id && id.startsWith('UserInfo_')) return 'UserInfo';
  if (id && id.startsWith('CurrentContractors_')) return 'CurrentContractors';
  if (id && id.startsWith('BillingsThisMonth_')) return 'BillingsThisMonth';
  if (id && id.startsWith('BillingsThisQtr_')) return 'BillingsThisQtr';
  if (id && id.startsWith('BillingsThisYear_')) return 'BillingsThisYear';
  if (id && id.startsWith('ForecastNextMonth_')) return 'ForecastNextMonth';
  if (id && id.startsWith('ForecastThisMonth_')) return 'ForecastThisMonth';
  if (id && id.startsWith('HistoricalBillings_')) return 'HistoricalBillings';
  if (id && id.startsWith('MyActiveInterviews_')) return 'MyActiveInterviews';
  if (id && id.startsWith('MyOpenJobs_')) return 'MyOpenJobs';
  if (id && id.startsWith('LinkButton_')) return 'LinkButton';
  if (id && id.startsWith('Activity_')) return 'Activity';
  if (id && id.startsWith('JobPipeline_')) return 'JobPipeline';
  if (id && id.startsWith('CandidatePipeline_')) return 'CandidatePipeline';
  if (id && id.startsWith('PlacementFees_')) return 'PlacementFees';
  if (id && id.startsWith('KPI_')) return 'KPI';
  if (id && id.startsWith('Ratio_')) return 'Ratio';
  if (id && id.startsWith('Revenue_')) return 'Revenue';
  if (id && id.startsWith('Dashboard_NotFound')) return 'Dashboard_NotFound';
  if (id && id.startsWith('Forecast_')) return 'Forecast';
  return '';
};

export const GetPanelDefinitionsFromPanelModels = (panels: ExtendedPanelModel[]) => {
  const elements: MainDashboardElementDefinition[] = [];
  panels.forEach((p, i) => {
    const type = GetElementTypeById(p.id ?? '');
    elements.push({
      id: p.id ?? i.toString(),
      sizeX: p.sizeX ?? 1,
      sizeY: p.sizeY ?? 1,
      col: p.col ?? 0,
      row: p.row ?? 0,
      minSizeX: p.minSizeX ?? 1,
      minSizeY: p.minSizeY ?? 1,
      maxSizeX: p.maxSizeX ?? null,
      maxSizeY: p.maxSizeY ?? null,
      type: type,
      config: p.config,
      defaultConfig: p.defaultConfig,
    });
  });
  return elements;
};
